import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { LanguageProvider } from './shell/language-context';
import { SettingsProvider } from './shell/settings-context';
import { SessionProvider } from './shell/session-context';
import { AuthGate } from './shell/auth-gate';
import { ThemeProvider } from './shell/theme-context';
import { ToastProvider } from './shell/toast';
import { SignOutOverlay } from './shell/sign-out-progress';
import './theme/theme.css';
import './theme/motion.css';
import { reloadOnStaleChunk } from './shell/reload-on-stale-chunk';

// SPA entry. The router owns all screens; ThemeProvider holds light/dark/system
// (CB-16), ToastProvider the toast stack (CB-17), LanguageProvider the en/bn choice
// (packages/i18n, DR-16), SettingsProvider the currency/money formatter, and
// SessionProvider the authenticated merchant + active-business selection consumed by
// every business-scoped screen.
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

// A tab left open across a deploy reloads instead of failing on a removed chunk.
reloadOnStaleChunk();

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <SettingsProvider>
          <SessionProvider>
            <ToastProvider>
              <AuthGate>
                <RouterProvider router={router} />
              </AuthGate>
              <SignOutOverlay />
            </ToastProvider>
          </SessionProvider>
        </SettingsProvider>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>,
);
